import type { Plan } from '../../../types';
import { DetailsCard } from '../../shared/PlanDetails';

export function MembershipIncludesBlock({ plans }: { plans: Plan[] }) {
  const unique = plans
    ? [...new Set<Plan>([...plans, 'Signature'])]
    : (['Signature'] as Plan[]);

  if (!unique.length) return <></>;

  if (unique.length == 1)
    return (
      <div className='grid grid-cols-2 gap-4 xl:grid-cols-4'>
        <div className='col-span-2 xl:col-start-2'>
          <DetailsCard plan={unique[0]} />
        </div>
      </div>
    );

  return (
    <div className='grid grid-cols-1 gap-8 xl:grid-cols-2'>
      {unique.includes('Platinum') && <DetailsCard plan='Platinum' />}
      {unique.includes('Signature') && <DetailsCard plan='Signature' />}
      {unique.includes('Pediatrics') && <DetailsCard plan='Pediatrics' />}
    </div>
  );
}
